import { FormItemTypes, IDictionary } from '@bimser/core';
import { IPropertyField } from '../../../../entities/common';
import VisualControl from '../../base/VisualControl';
import { IIframeProperties } from './entities/IIframeProperties';

export default class Iframe extends VisualControl {
	url: string;
	height: number;
	fillForm: boolean;
	targetName: string;

	constructor() {
		super();
		this.controlType = FormItemTypes.EControlTypes.Iframe;

		this.fillForm = false;
		this.height = 200;
	}

	__loadProperties(data: IIframeProperties) {
		super.__loadProperties(data);

		this.__proxyChanged.url = data.url;
		this.__proxyChanged.height = data.height;
		this.__proxyChanged.fillForm = data.fillForm;
		this.__proxyChanged.targetName = data.targetName;
	}

	__getPropertyFields(): IPropertyField[] {
		return [
			...super.__getPropertyFields(),
			{
				name: 'url',
				type: 'string',
				common: true
			},
			{
				name: 'fillForm',
				type: 'boolean'
			},
			{
				name: 'height',
				type: 'number'
			},
			{
				name: 'targetName',
				type: 'string',
				common: true
			}
		];
	}

	__getComponentData(): IDictionary<any> {
		return {
			...super.__getComponentData(),
			url: this.url,
			height: this.height,
			fillForm: this.fillForm,
			targetName: this.targetName
		};
	}

	__getHeight() {
		if (this.fillForm) {
			return this.__form.windowSize.height ? this.__form.windowSize.height - 70 : 400;
		}

		return this.height;
	}

	__render() {
		return super.__render(
			<iframe
				style={{ background: this.style.backgroundColor }}
				name={this.targetName}
				src={this.url}
				height={this.__getHeight()}
				width="100%"
			/>
		);
	}
}
